import React from 'react';

import DiscordLandingHelmet from 'common/helmets/DiscordLandingHelmet';
import InstallExtensionButton from 'common/integrations/InstallExtensionButton';
import LandingFooterCTA from 'common/LandingFooterCTA';
import LazyLoadedImage from 'common/LazyLoadedImage';

import CannyLogoIcon from 'img/canny-icon.svg';
import DiscordLogo from 'img/discord-logo.png';

import 'css/components/integrations/_IntegrationsLanding.scss';

const DiscordLanding = () => {
  return (
    <div className="integrationsLanding withoutImage">
      <DiscordLandingHelmet />
      <div className="integrationsLandingContainer">
        <div className="header">
          <div className="left">
            <div className="logosCombined">
              <LazyLoadedImage
                className="companyLogo"
                loading="eager"
                src={CannyLogoIcon}
                alt="Canny Logo"
              />
              +
              <LazyLoadedImage
                className="companyLogo"
                loading="eager"
                src={DiscordLogo}
                alt="Discord Logo"
              />
            </div>
            <div className="text">
              <h1 className="title">Canny’s Discord Integration</h1>
              <p className="subtitle">
                Get instant notifications in Discord from your Canny&nbsp;boards.
              </p>
              <div className="links">
                <InstallExtensionButton
                  installLink="https://canny.io/redirect?to=%2Fadmin%2Fsettings%2Fdiscord"
                  installButtonText="Install Extension"
                />
                <a
                  href="https://help.canny.io/en/articles/5807464-discord-integration"
                  rel="noopener"
                  target="_blank"
                  className="LandingIntegrations__install-link">
                  See install docs
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="features">
          <div className="featureHighlight">
            <div className="featureText">
              <h2 className="title">Notifications directly to your channels</h2>
              <p className="subtitle">
                Easily select which channels you want your notifications sent to.
              </p>
            </div>
          </div>
          <div className="featureHighlight">
            <div className="featureText">
              <h2 className="title">Control what events you’re notified about</h2>
              <p className="subtitle">
                Choose from new posts, comments, votes, vote milestones, status changes, and
                changelog entries.
              </p>
            </div>
          </div>
          <div className="featureHighlight">
            <div className="featureText">
              <h2 className="title">Keep notifications private</h2>
              <p className="subtitle">
                Connect Canny to a private Discord channel to restrict who sees your notifications.
              </p>
            </div>
          </div>
        </div>
        <LandingFooterCTA style="solid" />
      </div>
    </div>
  );
};

export default DiscordLanding;
